import { makeQueryOptions } from '@mint-lib/api-zod-support/react-query';

import { defaultApi } from '@mint-sdk/api-core';

import { WorkspacesResponseSchema } from './schemas.js';

export const workspaces = defaultApi.declareEndpoint({
  url: 'mdm/workspace/',
  method: 'GET',
  responseSchema: WorkspacesResponseSchema,
});

export const getWorkspaces = makeQueryOptions(workspaces, {
  processResponse(data) {
    return data.data;
  },
});
